import { Controller } from "@hotwired/stimulus"

// Watches preferred provider form fields and updates preview in real-time
export default class extends Controller {
  static values = {
    url: String
  }

  connect() {
    this.timeout = null
    this.form = this.element.closest('form')

    // Trigger initial preview render on page load
    if (this.form) {
      this.refreshPreview()
    }
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  // Debounce preview refresh to avoid excessive requests
  refreshPreview() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }

    this.timeout = setTimeout(() => {
      this.submitPreview()
    }, 300)
  }

  submitPreview() {
    if (!this.form) {
      return
    }

    // Preview is read-only. Use GET (like NPI lookup) and keep the query string small
    // to avoid URL length issues from large rule lists.
    const formData = new FormData(this.form)
    const url = new URL(this.urlValue, window.location.origin)

    const allowedKeys = new Set([
      "preferred_provider[identifier_value]",
      "preferred_provider[any_geo_location]",
      "preferred_provider[online_only]",
      "preferred_provider[url]",
      "preferred_provider[display_name]",
      "preferred_provider[display_image]",
      "preferred_provider[display_button_text]",
      "preferred_provider[display_button_url]"
    ])

    for (const [key, value] of formData.entries()) {
      if (!allowedKeys.has(key)) continue
      url.searchParams.set(key, value)
    }

    fetch(url, {
      method: "GET",
      headers: {
        "Accept": "text/vnd.turbo-stream.html"
      }
    })
      .then(response => {
        const contentType = response.headers.get("Content-Type") || ""
        return response.text().then((body) => ({ ok: response.ok, contentType, body }))
      })
      .then(({ ok, contentType, body }) => {
        // If we got redirected to an HTML page (e.g., auth/maintenance), Turbo won't render anything.
        // Show a small inline error so it's obvious what's happening.
        if (!ok || !contentType.includes("text/vnd.turbo-stream.html")) {
          const container = document.getElementById("preferred-provider-preview")
          if (container) {
            container.innerHTML = "<div class='text-sm text-alert-red-600'>Could not load preview.</div>"
          }
          return
        }

        Turbo.renderStreamMessage(body)
      })
      .catch(() => {
        const container = document.getElementById("preferred-provider-preview")
        if (container) {
          container.innerHTML = "<div class='text-sm text-alert-red-600'>Could not load preview.</div>"
        }
      })
  }
}

